export const SHOPIFY_CUSTOMER_TYPE = {
  ACCOUNT_ID: 'account_id',
  END_CUSTOMER: 'end_customer',
};

export const ShopifyAppType = {
  RETAILER: 'retailer',
  MARKETPLACE: 'marketplace',
};
